<template lang="pug">
  div.legend__group
    div.legend__type(
      :class="className"
    )
      div.legend__name.semibold {{$translate('Региональные операторы')}}
    .legend__small-group
      .custom-checkbox(
        v-for="item in list" :key="item.id"
      )
        input.visually-hidden.custom-checkbox__input(
          type="checkbox"
          :id="'checkbox-regop-' + item.id"
          :value="item.id"
          @change="updateRegop"
        )
        label.legend__label.custom-checkbox__label(:for="'checkbox-regop-' + item.id")
          span.custom-checkbox__block
          span.custom-checkbox__text {{item.name}}
</template>

<script>
import { atu } from '@/api/api-endpoints'

export default {
  name: 'map-regop',
  props: {
    className: {
      type: String,
      default: 'type legend__type_with-small',
    },
  },
  data: () => ({
    list: [],
  }),
  methods: {
    async getApo() {
      const list = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.apoName(),
        })
      ).data.data
      this.list = list.map((item) => {
        item.checked = false
        return item
      })
    },
    async updateRegop(event) {
      const selectedItem = this.list.find(
        (item) => item.id === Number(event.target.value)
      )
      selectedItem.checked = !selectedItem.checked
      this.$emit('updateRegop', this.list)
    },
  },
  created() {
    this.getApo()
  },
}
</script>
